import { Injectable } from '@angular/core';
import { Stores } from './stores.model';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class StoresService {

  storeData :Stores;

  constructor(private firestore:AngularFirestore) { }
  getStores(){
    return this.firestore.collection('stores').snapshotChanges();
  }
  getSingleStores(id: string){
    return this.firestore.collection('stores', ref => ref.where('id', '==', id)).valueChanges();
  }
}
